/**
 * captureUTMParams — Captura UTM params y click IDs desde la URL actual.
 *
 * Estrategia de persistencia:
 *   1. Si el param existe en la URL → usarlo y guardarlo en sessionStorage.
 *   2. Si no está en la URL → recuperar desde sessionStorage (navegación interna).
 *   3. Si tampoco está en sessionStorage → string vacío.
 *
 * Esto garantiza que el lead lleve atribución aunque el usuario navegue
 * entre pasos o recargue la página.
 */
export function captureUTMParams() {
  const params = new URLSearchParams(window.location.search);

  const utm = {
    utm_source:   params.get('utm_source')   || sessionStorage.getItem('utm_source')   || '',
    utm_medium:   params.get('utm_medium')   || sessionStorage.getItem('utm_medium')   || '',
    utm_campaign: params.get('utm_campaign') || sessionStorage.getItem('utm_campaign') || '',
    utm_content:  params.get('utm_content')  || sessionStorage.getItem('utm_content')  || '',
    utm_term:     params.get('utm_term')     || sessionStorage.getItem('utm_term')     || '',
    gclid:        params.get('gclid')        || sessionStorage.getItem('gclid')        || '',
    fbclid:       params.get('fbclid')       || sessionStorage.getItem('fbclid')       || '',
    referrer_url: document.referrer || '',
    lead_source:  'exconvento_cotizador',
  };

  // Persistir en sessionStorage para sobrevivir navegación interna.
  // Solo persiste claves con valor para no sobreescribir con vacíos.
  Object.entries(utm).forEach(([k, v]) => {
    if (v) sessionStorage.setItem(k, v);
  });

  return utm;
}
